<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    if (this.$route.path !== "/all") {
      this.$router.replace("/all");
    }
  }
};
</script>

<style lang="scss" >
div,
li,
a,
input {
  box-sizing: border-box;
}
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
@font-face {
  font-family: "gekko_fonts";
  src: url("../static/fonts/gekko_fonts.ttf?v20ah2") format("truetype"),
    url("../static/fonts/gekko_fonts.woff?v20ah2") format("woff"),
    url("../static/fonts/gekko_fonts.svg?v20ah2#gekko_fonts") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "gekko_fonts" !important;
  speak: none;
  font-size: 1rem;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.tag {
  @include flex;
  position: relative;
  border-color: $border-color transparent transparent $border-color;
  margin: 5px 12px 0 0;
  height: 22px;
  cursor: pointer;
  span {
    box-sizing: border-box;
  }
  & > span:first-child {
    height: 20px;
    width: 20px;
    left: -16px;
    position: absolute;
    z-index: 10;
    overflow: hidden;
    top: 50%;
    transform: translateY(-50%);
    & > span {
      position: absolute;
      display: inline-block;
      right: -16px;
      bottom: -1.6px;
      transition: all 200ms;
      -webkit-transform-origin: left bottom;
      transform-origin: left bottom;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      border: 1px solid $border-color;
      border-radius: 4px;
      width: 16.4px;
      height: 16.5px;
      background-color: $base-color;
    }
  }
  & > span:last-child {
    display: inline-block;
    position: relative;
    border: 1px solid $border-color;
    border-left: transparent;
    border-radius: 4px;
    padding: 0 5px 0 8px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    transition: all 200ms;
    color: $light-purple;
  }
  &::after {
    content: "";
    z-index: 20;
    width: 0;
    height: 0;
    position: absolute;
    border-radius: 50%;
    transition: all 200ms;
    border: 2px solid $border-color;
    left: -2px;
    top: 8px;
  }
  &.select {
    &::after {
      border-color: $base-color;
    }
    & > span:last-child {
      background-color: $light-purple;
      border-color: $light-purple;
      color: $base-color;
    }
    & > span:first-child > span {
      background-color: $light-purple;
      border-color: $light-purple;
    }
    &:hover {
      &::after {
        border-color: $base-color;
      }
      & > span:last-child {
        border-color: $dark-purple;
      }
      & > span:first-child > span {
        border-color: $dark-purple;
      }
    }
  }

  &:hover {
    border-color: $light-purple;
    & > span:last-child,
    &::after {
      border-color: $light-purple;
    }
    & > span:first-child > span {
      border-color: $light-purple;
    }
  }
  .text {
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 175px;
  }
}

@media screen and (min-width: 1600px) {
  .case-wrapper,
  .item-wrapper {
    flex-basis: 20% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue